export const environment = {
    apiBaseUrl: '/api/v1',
    firebaseOptions: {
        apiKey: 'AIzaSyAzkdV7IBytV5irR2B2C5cdrmlc20k-ijU',
        authDomain: 'botmoderator-5f6bf.firebaseapp.com',
        projectId: 'botmoderator-5f6bf',
        storageBucket: 'botmoderator-5f6bf.firebasestorage.app',
        messagingSenderId: '736102889007',
        appId: '1:736102889007:web:b54bc62c3ec26eba7538da',
        measurementId: 'G-K4D8G9LQM2'
    }
};
